import { memo } from "react";
import { LuDumbbell, LuHeartPulse, LuScale, LuSparkles, LuWheat } from "react-icons/lu";

const ICONS = { MUSCLE: LuDumbbell, HEART: LuHeartPulse, FIBER: LuWheat, WEIGHT: LuScale, MICRONUTRIENTS: LuSparkles };

/**
 * Benefit icons from the nutrition service's benefits engine. Each one is
 * backed by a claim threshold on the product's own label; none are written
 * in the app. The explanation is the tooltip / accessible description.
 */
function ProductBenefits({ benefits }) {
  if (!benefits?.length) {
    return (
      <p className="ep-prose">
        No benefits can be claimed yet: the nutrition label needs more detail before we can say what this product is
        good for.
      </p>
    );
  }
  return (
    <ul className="ep-benefits" style={{ listStyle: "none", margin: 0, padding: 0 }}>
      {benefits.map((benefit) => {
        const Icon = ICONS[benefit.code] ?? LuSparkles;
        return (
          <li key={benefit.code} className="ep-benefit" title={benefit.description}>
            <span className="ep-benefit-icon" aria-hidden="true">
              <Icon />
            </span>
            <span>{benefit.title}</span>
            <span className="ep-visually-hidden">{benefit.description}</span>
          </li>
        );
      })}
    </ul>
  );
}

export default memo(ProductBenefits);
